<template>
  <div v-if="childItem.propsValue.data.length > 0">
    <div v-if="className == 'mk-subject-banner2'" class="mk-subject-banner2">
      <div class="swiper mk-subject-jump-swiper">
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in [childItem.propsValue.data[0]]"
            :key="index"
          >
            <img v-if="item.customField1" class="mk-subject-jump-logo" :src="item.customField1" alt />
            <div v-if="item.customField2" class="mk-subject-jump-title">{{ item.customField2 }}</div>
            <div
              v-if="item.customField3"
              class="mk-subject-jump-summary"
              v-html="item.customField3"
            ></div>
            <div class="mk-subject-jump-btn">
              <img
                v-if="item.customField4.text"
                src="https://mks.yybip.com/group1/M00/0B/5E/CgoRC2iC3C-AOfYUAAAhyh8FvCY479.png"
                alt
              />
              <img
                v-if="item.customField5.text"
                src="https://mks.yybip.com/group1/M00/03/AE/CgoRDGiC27GAEFUqAAAf-mAzG_8477.png"
                alt
              />
            </div>
            <div class="mk-subject-jump-modules" v-if="item.customField6.contentImage">
              <!-- 图片 -->
              <img :src="item.customField6.contentImage | imgUrl" alt />
              <img
                v-if="item.customField6.contentType == 'video'"
                class="video-block-play"
                src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
              />
            </div>
          </div>
        </div>
        <!-- <div class="swiper-pagination"></div> -->
      </div>
    </div>
    <div v-if="className == 'mk-subject-details'" class="mk-subject-details">
      <div v-for="(item, index) in [childItem.propsValue.data[0]]" :key="index">
        <div class="mk-subject-title">{{ item.customField2 }}</div>
        <div class="mk-subject-summary" v-html="item.customField3"></div>
        <div class="mk-subject-jump-btn" v-if="item.customField4.text || item.customField5.text">
          <img
            v-if="item.customField4.text"
            src="https://mks.yybip.com/group1/M00/0B/5E/CgoRC2iC3C-AOfYUAAAhyh8FvCY479.png"
            alt
          />
          <img
            v-if="item.customField5.text"
            src="https://mks.yybip.com/group1/M00/03/AE/CgoRDGiC27GAEFUqAAAf-mAzG_8477.png"
            alt
          />
        </div>
        <div class="mk-subject-details-video">
          <img :src="item.customField6.contentImage | imgUrl" alt />
          <img
            v-if="item.customField6.contentType == 'video'"
            class="video-block-play"
            src="https://mks.yybip.com/group1/M00/01/F7/CgoRDGSAPjeATLhuAAAHsdousik151.png"
          />
        </div>
      </div>
    </div>
  </div>
</template>
// mk-subject-details
<script>
import {
  buttonObject,
  contentObject
} from "@/modules/autoweb/config/elementObject.js";
let buttonObjectTemp1 = _.cloneDeep(buttonObject);
buttonObjectTemp1.text = "免费试用";
let buttonObjectTemp2 = _.cloneDeep(buttonObject);
buttonObjectTemp2.text = "了解详情";
export default {
  name: "MkBanner2Phone",
  props: {
    element: {
      type: Object,
      default: () => {
        return {};
      }
    },
    childItem: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  computed: {
    className() {
      let selectClass = _.filter(this.element.class, item => item.selected)[0];
      return selectClass.value;
    }
  },
  data() {
    return {
      fields: [
        {
          code: "customField1",
          label: "图片",
          type: "image",
          width: 120,
          height: 15
        },
        {
          code: "customField2",
          label: "标题",
          type: "text"
        },
        {
          code: "customField3",
          label: "介绍",
          type: "text"
        },
        {
          code: "customField4",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField5",
          label: "按钮",
          type: "button"
        },
        {
          code: "customField6",
          label: "素材",
          type: "content",
          contentType: "image,video",
          defaultType: "image",
          width: 306,
          height: 150,
          isMultiple: false
        }
      ],
      data: [
        {
          customField1:
            "https://mks.yybip.com/group1/M00/03/AE/CgoRDGiCR8GAXw1rAAAg7ZLbgwc511.png",
          customField2: "数智融合 价值财务",
          customField3:
            "运用AI技术，助力企业实现价值财务升级成功护航28000+大型企业财务数智化转型",
          customField4: _.cloneDeep(buttonObjectTemp1),
          customField5: _.cloneDeep(buttonObjectTemp2),
          customField6: _.cloneDeep(contentObject)
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss">
.mk-subject-banner2 {
  background-size: 100% 100%;
  border-bottom: 1px solid #e1e1e1;
  padding-bottom: 0.4rem;
  .swiper-slide {
    text-align: center;
  }
  .mk-subject-jump-logo {
    margin-top: 0.7rem;
    height: 0.26rem;
    width: auto;
  }
  .mk-subject-jump-title {
    margin: 0.32rem 0 0.24rem;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.49rem;
    color: #515051;
    line-height: 0.39rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .mk-subject-jump-summary {
    margin: 0 0.69rem 0.33rem;
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.36rem;
    text-align: center;
    font-style: normal;
    text-transform: none;
  }
  .mk-subject-jump-btn {
    height: 0.58rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-bottom: 0.36rem;
    img {
      height: 100%;
      width: auto;
    }
  }
  .mk-subject-jump-modules {
    margin: 0 0.69rem;
    margin-bottom: 0.36rem;
    height: 3rem;
    position: relative;
    video {
      width: 100%;
      height: 100%;
      border: 0.14rem solid #d9d1e3;
      border-radius: 0.14rem;
      box-sizing: border-box;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .video-block-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }
}
.mk-subject-details {
  padding: 0.56rem 0.42rem 0.42rem;
  background-color: #f0f0f0;
  text-align: center;
  .mk-subject-title {
    font-family: AlibabaPuHuiTi_3_85_Bold;
    font-size: 0.33rem;
    color: #e60012;
    line-height: 0.39rem;
    text-align: center;
    font-weight: bold;
    margin-bottom: 0.15rem;
  }
  .mk-subject-summary {
    font-family: AlibabaPuHuiTi_3_55_Regular;
    font-size: 0.24rem;
    color: #717071;
    line-height: 0.42rem;
    text-align: center;
    margin-bottom: 0.36rem;
  }
  .mk-subject-jump-btn {
    height: 0.58rem;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.4rem;
    margin-bottom: 0.36rem;
    img {
      height: 100%;
      width: auto;
    }
  }
  .mk-subject-details-video {
    height: 3rem;
    position: relative;
    video {
      width: 100%;
      height: 100%;
      border: 0.14rem solid #d9d1e3;
      border-radius: 0.14rem;
      box-sizing: border-box;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .video-block-play {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      width: 50px;
      height: 50px;
      cursor: pointer;
    }
  }
}
</style>
